import Accordion from 'entities/Accordion'
import { CheckBox } from 'entities/ChekBox'
import { BookingVariantSelector } from 'features/BookingVariantSelector'
import { PaymentOrderSelector } from 'features/PaymentOrder'
import { PaymentProviderSelector } from 'features/PaymentProviderSelector'
import { getAppName } from 'shared/helpers/getAppName'
import { RenderIf } from 'shared/helpers/renderIf'
import { useConfigStore } from 'shared/store/configSlice'
import { useGlobalStore } from 'shared/store/globalSlice'

export const PaymentOptionsAccordion = () => {
  const updateMenuConfig = useConfigStore().updateMenuConfig
  const config = useConfigStore().config?.menuConfig
  const isCC = useGlobalStore().isCCSelected

  const handleNotes = (value: boolean) => {
    updateMenuConfig({ notesAvailable: value ? 1 : 0 })
  }

  const handleTips = (value: boolean) => {
    updateMenuConfig({ tips: value ? 1 : 0 })
  }

  const handleSelfService = (value: boolean) => {
    updateMenuConfig({ selfService: value ? 1 : 0 })
  }

  return (
    <Accordion title='Payment options' defaultExpanded>
      <RenderIf condition={!isCC}>
        <BookingVariantSelector />
      </RenderIf>
      {/* TODO: disable PaymentOrderSelector if ONLY VIEW is selected */}
      <PaymentProviderSelector />
      <RenderIf condition={!isCC && config?.[getAppName(isCC)]?.bookingVariant !== 1}>
        <PaymentOrderSelector />
      </RenderIf>
      <CheckBox
        checked={config?.[getAppName(isCC)]?.notesAvailable === 1}
        handleChange={handleNotes}
        label='Customer can add notes'
      />
      <RenderIf condition={!isCC}>
        <CheckBox checked={config?.QRMENU?.tips === 1} handleChange={handleTips} label='Tips' />
      </RenderIf>
      <RenderIf condition={!isCC && config?.QRMENU?.paymentVariant === 1}>
        <CheckBox
          checked={Boolean(config?.QRMENU?.selfService)}
          handleChange={handleSelfService}
          label='Self service'
        />
      </RenderIf>
    </Accordion>
  )
}
